// @ts-nocheck 0a562e39
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['add_section_label_rich_text_box'],
      sections: [addPanel.sections.getSections().developer.richTextBoxSection],
    };
  },
};
